import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { endpoints } from '../common/api-endpoints';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class ContentService extends DataService {
  constructor(httpClient: HttpClient) {
    super(endpoints.content, httpClient);
  }

  createFromTemplate(contentId, title, parentId, emoji = '') {
    const datas = { contentId, title, parentId ,emoji};
    
    return this.http.post(this.url + 'createfromtemplate', datas).toPromise();
  }
}
